import { useState, useEffect, useCallback } from 'react'
import { supabase } from '../supabase'
import { useAuth } from './useAuth'

// ── CHURCH NOTICES (Community "All" feed, pinned strip) ─────────────────
// RLS already filters to non-removed, non-expired (pinned_until >= today)
// rows for the caller's own church — no client-side re-filtering needed.

export function useNotices(churchIdOverride) {
  const [notices, setNotices] = useState([])
  const [loading, setLoading] = useState(true)
  const { profile } = useAuth()
  const churchId = churchIdOverride || profile?.church_id

  const fetch = useCallback(async () => {
    if (!churchId) { setNotices([]); setLoading(false); return }
    setLoading(true)
    const { data, error } = await supabase
      .from('church_notices')
      .select('*')
      .eq('church_id', churchId)
      .order('created_at', { ascending: false })
    if (error) {
      console.error('useNotices load:', error)
      setNotices([])
      setLoading(false)
      return
    }
    setNotices(data || [])
    setLoading(false)
  }, [churchId])

  useEffect(() => { fetch() }, [fetch])

  return { notices, loading, refresh: fetch }
}
